var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container is-fluid" },
      [
        _c(
          "b-field",
          [
            _c(
              "b-button",
              {
                attrs: { "icon-left": "arrow-left" },
                on: {
                  click: function ($event) {
                    return _vm.$router.go(-1)
                  },
                },
              },
              [_vm._v(" Back ")]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-7" }, [
            _vm.file
              ? _c(
                  "div",
                  [
                    _c("p", { staticClass: "title is-4 is-inline" }, [
                      _vm._v(" " + _vm._s(_vm.file.filename) + " "),
                    ]),
                    _c(
                      "div",
                      { staticClass: "buttons is-inline" },
                      [
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "Delete shipping file",
                              type: "is-danger",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                size: "is-small",
                                type: "is-danger",
                                rounded: "",
                                outlined: "",
                                "icon-left": "trash-alt",
                                disabled: _vm.file.process_status === 1,
                              },
                              on: { click: _vm.deleteAll },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-tooltip",
                          {
                            attrs: { label: "Download file", type: "is-info" },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                size: "is-small",
                                type: "is-info",
                                rounded: "",
                                outlined: "",
                                "icon-left": "download",
                                loading: _vm.isDownloading,
                              },
                              on: { click: _vm.downloadFile },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-tooltip",
                          {
                            attrs: {
                              label: "Check lines validity",
                              type: "is-link",
                            },
                          },
                          [
                            _c("b-button", {
                              attrs: {
                                size: "is-small",
                                type: "is-link",
                                rounded: "",
                                outlined: "",
                                "icon-left": "clipboard-check",
                                loading: _vm.isFetching.checkup,
                              },
                              on: { click: _vm.checkup },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "b-tooltip",
                          { attrs: { label: "Integrate all valid lines" } },
                          [
                            _c("b-button", {
                              attrs: {
                                size: "is-small",
                                type: "is-primary",
                                rounded: "",
                                outlined: "",
                                "icon-left": "check",
                                disabled: _vm.file.process_status === 1,
                                loading: _vm.isFetching.integrate,
                              },
                              on: { click: _vm.integrate },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.allInvalidConsinee.length !== 0
                      ? _c(
                          "b-message",
                          {
                            attrs: {
                              type: "is-warning",
                              title: "All Invalid Consinee",
                              closable: false,
                            },
                          },
                          _vm._l(_vm.allInvalidConsinee, function (el, i) {
                            return _c("h5", { key: i }, [
                              _vm._v(" " + _vm._s(el) + " "),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                    _c("p", { staticClass: "subtitle" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.file.customerId) +
                          " - " +
                          _vm._s(_vm.file.table) +
                          " "
                      ),
                    ]),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "has-text-centered" },
                  [
                    _c("b-icon", {
                      attrs: {
                        pack: "fas",
                        icon: "sync-alt",
                        size: "is-large",
                        "custom-class": "fa-spin",
                      },
                    }),
                  ],
                  1
                ),
          ]),
          _c("div", { staticClass: "column is-offset-1 is-3" }, [
            _c("nav", { staticClass: "level is-mobile has-text-centered" }, [
              _c("div", { staticClass: "level-item has-text-centered" }, [
                _c("div", [
                  _c("p", { staticClass: "heading" }, [_vm._v(" Valid ")]),
                  _c("p", { staticClass: "title" }, [
                    _vm._v(" " + _vm._s(_vm.validTotalCount) + " "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "level-item has-text-centered" }, [
                _c("div", [
                  _c("p", { staticClass: "heading has-text-primary" }, [
                    _vm._v(" Sent "),
                  ]),
                  _c("p", { staticClass: "title" }, [
                    _vm._v(" " + _vm._s(_vm.sentTotalCount) + " "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "level-item has-text-centered" }, [
                _c("div", [
                  _c("p", { staticClass: "heading has-text-warning" }, [
                    _vm._v(" Warnings "),
                  ]),
                  _c("p", { staticClass: "title" }, [
                    _vm._v(" " + _vm._s(_vm.warningTotalCount) + " "),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "level-item has-text-centered" }, [
                _c("div", [
                  _c("p", { staticClass: "heading has-text-danger" }, [
                    _vm._v(" Errors "),
                  ]),
                  _c("p", { staticClass: "title" }, [
                    _vm._v(" " + _vm._s(_vm.errorTotalCount) + " "),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "buttons" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { type: "is-danger", "icon-left": "minus" },
                    on: { click: _vm.deleteSelectedRows },
                  },
                  [_vm._v(" Delete selected rows ")]
                ),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("ag-grid-vue", {
                staticClass: "ag-theme-balham",
                staticStyle: { width: "100%", height: "700px" },
                attrs: {
                  "row-data": _vm.lines,
                  "grid-options": _vm.gridOptions,
                  pagination: true,
                  "animate-rows": true,
                  "row-selection": "multiple",
                  "pagination-auto-page-size": true,
                  "suppress-row-click-selection": true,
                  "side-bar": ["columns"],
                  "multi-sort-key": "ctrl",
                  modules: _vm.modules,
                },
                on: {
                  cellValueChanged: _vm.cellValueChanged,
                  "grid-ready": _vm.gridReady,
                },
              }),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }